import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import ContinuousAssumptionsCard from "components/UnifiedProject/Optimize/Double/Subcomponents/ContinuousAssumptionsCard";

import * as setupReducer from "containers/Setup/reducer";
import * as projectReducer from "containers/Project/reducer";

export const getRunId = (props) =>
  props && props.id
    ? props.id
    : props && props.match && props.match.params && props.match.params.runId
      ? props.match.params.runId
      : 2860;

class ContinuousAssumptionsCardContainer extends React.PureComponent {
  q;
  constructor(props) {
    super(props);
  }

  render() {
    const { setup } = this.props;
    return setup !== undefined && Object.keys(setup).length > 0 ? (
      <ContinuousAssumptionsCard {...this.props} />
    ) : (
      <LoadingIndicator />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getRunId(ownProps);
  return {
    updateIsRealityHammer: (runId, isRealityHammer) => {
      dispatch(setupReducer.updateIsRealityHammer(runId, isRealityHammer));
      dispatch(projectReducer.resetBudget(id));
    },
    updateExpectedCountContinuous: (runId, val) => dispatch(setupReducer.updateExpectedCountContinuous(runId, val)),
    updateExpectedValueContinuous: (runId, val) => dispatch(setupReducer.updateExpectedValueContinuous(runId, val))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = getRunId(ownProps);

  //optimized used to check for other things
  let optimized = ownProps.optimized;
  if (!optimized || optimized.projectId !== id) {
    optimized = projectReducer.getOptimized(state, id);
  }

  const runId =
    ownProps.isEditBlueprint && ownProps.editBlueprintId !== undefined
      ? ownProps.editBlueprintId
      : optimized && optimized.innerId !== undefined
        ? optimized.innerId
        : id;

  const setup =
    ownProps.isEditBlueprint && ownProps.editBlueprintId !== undefined
      ? setupReducer.getSetup(state, runId)
      : optimized && optimized.setup
        ? optimized.setup
        : setupReducer.getSetup(state, id);

  return {
    runId: runId,
    setup: setup,
    optimized: optimized,
    isRealityHammer: setupReducer.getIsRealityHammer(state, runId),
    isOverallSegment: projectReducer.getIsOverallSegment(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ContinuousAssumptionsCardContainer);
